import styled from 'styled-components';

const getDimOpacity = (brightness: number) =>
	1 - Math.min(Math.max(brightness, 0), 1);

const StyledCloseZone = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
`;

const StyledCloseZoneTop = styled(StyledCloseZone)`
	height: calc(100% - 600px - 50px);
`;

const StyledCloseZoneLeft = styled(StyledCloseZone)`
	width: calc(100% - 400px - 40px - 50px);
	height: 100%;
`;

const StyledCloseZoneRight = styled(StyledCloseZone)`
	left: inherit;
	right: 0;
	width: calc(40px - 50px);
	height: 100%;
`;

const StyledContainer = styled.div<{ $showNotification: boolean }>`
	position: absolute;
	right: 40px;
	bottom: ${({ $showNotification }) => ($showNotification ? '-446px' : '0')};
	width: 400px;
	height: 600px;
	z-index: 1000;
	transform: translate(0, 200%);
	transition: transform 0.3s ease;
`;

const StyledScreen = styled.div`
	position: absolute;
	inset: 0;
	background-color: #000000;
	border-radius: 60px 60px 0 0;
`;

const ScreenContainer = styled.div<{ $brightness: number }>`
	position: absolute;
	top: 10px;
	left: 10px;
	width: 380px;
	height: 590px;
	border-radius: 50px 50px 0 0;
	overflow: hidden;
	background-color: #111111;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		background-color: rgba(
			0,
			0,
			0,
			${({ $brightness }) => getDimOpacity($brightness)}
		);
		pointer-events: none;
	}
`;

const StyledScreenLight = styled.div`
	position: absolute;
	inset: 0;
	opacity: 0.15;
	background: linear-gradient(
		147.22deg,
		#ffffff 0%,
		rgba(255, 255, 255, 0) 40%
	);
	pointer-events: none;
`;

const StyledScreenMask = styled.div`
	position: absolute;
	z-index: 10;
	top: 10px;
	left: 10px;
	width: 380px;
	height: 590px;
	border-radius: 50px 50px 0 0;
	background-color: #111111;
	pointer-events: none;
`;

export {
	ScreenContainer,
	StyledCloseZoneLeft,
	StyledCloseZoneRight,
	StyledCloseZoneTop,
	StyledContainer,
	StyledScreen,
	StyledScreenLight,
	StyledScreenMask,
};
